define("calendar/components/calendar/settings/bttp/business-account", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.needsProfessional}}
    <h5 class="u--text--md u--m__b__xs u--m__t__0">
      {{t "bttp.business_required_title"}}
    </h5>
    <p class="u--text--light u--m__b">
      {{html-safe (t "bttp.business_required_details")}}
    </p>
    <Shared::Link
      @href="https://help.later.com/hc/en-us/articles/360042770474"
      @text={{@upgradeButtonText}}
      class="o--btn o--btn--outline u--m__tb"
      data-test-id="bttp-setup-business"
    />
  {{else}}
    <h5 class="u--text--md u--m__t__0 u--m__b__xs">
      {{t this.connectBusinessTitle}}
    </h5>
    <p class="u--text--light">
      {{html-safe (t this.connectBusinessDetails)}}
    </p>
    {{#if this.isTiktok}}
      <Shared::Ui::Button
        @onClick={{this.refreshTiktokToken}}
        class="o--btn o--btn--outline u--m__tb"
        data-test-id="bttp-setup-business"
      >
        {{@upgradeButtonText}}
      </Shared::Ui::Button>
    {{else}}
      <Shared::Credentials::UpgradeButton
        @buttonText={{@upgradeButtonText}}
        @path="cluster.schedule.calendar"
        @socialProfile={{@singleSocialProfile}}
        class="u--m__tb"
        data-test-id="bttp-connect-business"
      />
    {{/if}}
  {{/if}}
  {{#unless @isOnLegacyPlan}}
    <Calendar::Settings::Bttp::InfoCard />
  {{/unless}}
  */
  {
    "id": "BsbCwwIA",
    "block": "[[[41,[30,0,[\"needsProfessional\"]],[[[1,\"  \"],[10,\"h5\"],[14,0,\"u--text--md u--m__b__xs u--m__t__0\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"bttp.business_required_title\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--text--light u--m__b\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[[28,[37,1],[\"bttp.business_required_details\"],null]],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,3],[[24,0,\"o--btn o--btn--outline u--m__tb\"],[24,\"data-test-id\",\"bttp-setup-business\"]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/en-us/articles/360042770474\",[30,1]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,\"h5\"],[14,0,\"u--text--md u--m__t__0 u--m__b__xs\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[[30,0,[\"connectBusinessTitle\"]]],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[[28,[37,1],[[30,0,[\"connectBusinessDetails\"]]],null]],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,0,[\"isTiktok\"]],[[[1,\"    \"],[8,[39,4],[[24,0,\"o--btn o--btn--outline u--m__tb\"],[24,\"data-test-id\",\"bttp-setup-business\"]],[[\"@onClick\"],[[30,0,[\"refreshTiktokToken\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[1,[30,1]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,5],[[24,0,\"u--m__tb\"],[24,\"data-test-id\",\"bttp-connect-business\"]],[[\"@buttonText\",\"@path\",\"@socialProfile\"],[[30,1],\"cluster.schedule.calendar\",[30,2]]],null],[1,\"\\n\"]],[]]]],[]]],[41,[51,[30,3]],[[[1,\"  \"],[8,[39,7],null,null,null],[1,\"\\n\"]],[]],null]],[\"@upgradeButtonText\",\"@singleSocialProfile\",\"@isOnLegacyPlan\"],false,[\"if\",\"t\",\"html-safe\",\"shared/link\",\"shared/ui/button\",\"shared/credentials/upgrade-button\",\"unless\",\"calendar/settings/bttp/info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/business-account.hbs",
    "isStrictMode": false
  });
  let BusinessAccountComponent = _exports.default = (_class = class BusinessAccountComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "tiktok", _descriptor, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);
    }
    get needsProfessional() {
      return this.args.needsProfessional && !this.isTiktok;
    }
    get isTiktok() {
      return Boolean(this.selectedSocialProfiles?.firstProfile?.isTiktok);
    }
    get connectBusinessTitle() {
      return this.isTiktok ? 'bttp.tiktok.connect_business_title' : 'bttp.connect_business_title';
    }
    get connectBusinessDetails() {
      return this.isTiktok ? 'bttp.tiktok.connect_business_details' : 'bttp.connect_business_details';
    }
    refreshTiktokToken() {
      this.tiktok.loginWithBusinessApiAccount(this.selectedSocialProfiles?.firstProfile);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "refreshTiktokToken", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshTiktokToken"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BusinessAccountComponent);
});